import request from '@/utils/request'

/**
 * 获取报表组列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回报表组列表
 */
export function listReportCustomGroup(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomGroup.listReportCustomGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加报表组
 * @param {Object} data 报表组数据
 * @returns {Promise} 返回操作结果
 */
export function saveReportCustomGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomGroup.saveReportCustomGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改报表组
 * @param {Object} data 报表组数据
 * @returns {Promise} 返回操作结果
 */
export function updateReportCustomGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomGroup.updateReportCustomGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除报表组
 * @param {Object} data 报表组数据
 * @returns {Promise} 返回操作结果
 */
export function deleteReportCustomGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomGroup.deleteReportCustomGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}